
const servicesBaseUrl = 'services/new-appointment/appointment/api';

const ApiConfigs = {
  baseUrls: {
    userInfo: 'api/UserInfo',
    newAppointment: {
      regionList: `${servicesBaseUrl}/lookups/regions`,
      departmentList: `${servicesBaseUrl}/lookups/sites`,
      serviceList: `${servicesBaseUrl}/lookups/departments`,
      availableDatesList: `${servicesBaseUrl}/calendar`,
      requestAppointment: `self-${servicesBaseUrl}/departments`,
    },
    appointmentDetails: {
      getAppointmentData: 'services/appointment-details/appointment/api/appointments-validations',
    },
    appointmentsList: {
      getAppointments: 'self-services/appointments-list/appointment/api/people',
    },
  },
};

export {
  ApiConfigs,
};
